var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathCatSnowmobiling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "30.3,31.2 40.2,31.2 41.6,29.8 31.6,29.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.76,14.86c1.33-0.02,2.38-1.11,2.36-2.44s-1.11-2.38-2.44-2.36 c-1.32,0.02-2.38,1.11-2.36,2.44C20.35,13.83,21.44,14.88,22.76,14.86C22.76,14.86,22.76,14.86,22.76,14.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.82,27.71l2.83-5.03l-6.26-3.82l-5.69,9.19h-1.65l4.01-6.22l-4.67-0.08l0.5-1.34l1.5,0.04 l3.54-0.24l1.13-1.82l-4.13-0.14l-3.2-2.39l-2.27-0.46l-3.37,9.13l5.71,0.05l-0.88,1.35h-6.91l0.64-1.58l-3.2,0.03l-1.79,3.74 l-3.79,0.01l-0.07,2.97h20.26l4.49-3.41L33.82,27.71z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathCatSnowmobiling);
export default __webpack_public_path__ + "static/media/path-cat-snowmobiling.b16e438a.svg";
export { ForwardRef as ReactComponent };